/*
 * lyrics-lang.js — на каком языке текст песни. Один владелец вопроса для
 * выравнивания текста по голосу (karaoke-autosync.js): от ответа зависит, какими
 * ФОНЕМАМИ espeak-ng прочтёт слова, а фонемная модель слышит звуки, а не буквы.
 *
 * Письменность решает сама: кириллица (украинская, если есть і/ї/є/ґ), хангыль,
 * арабское письмо. Латиницу решают служебные слова — их в любой песне десятки,
 * и они почти не пересекаются между языками; общие («in», «de», «la») весят
 * меньше, чем собственные. Локаль страницы — только подсказка на ничью.
 *
 * Строка на ДРУГОМ языке внутри песни (английский припев в немецкой песне)
 * отмечается отдельно (`perLine`): строка уходит в свой язык, только если в ней
 * ≥2 служебных слова того языка и ни одного — языка песни.
 *
 *   LyricsLang.detect(lines, { hint: 'de' }) → {
 *       lang,        // 'en' | 'de' | … | 'ru' | 'uk' | 'ko' | 'ar' | null
 *       script,      // 'latin' | 'cyrillic' | 'hangul' | 'arabic' | 'other' | 'none'
 *       confident,   // служебные слова решили, а не подсказка
 *       perLine,     // язык каждой строки
 *       scores,      // {lang: вес} — для телеметрии
 *   }
 */
(function (root, factory) {
    var api = factory();
    if (typeof module === 'object' && module.exports) module.exports = api;
    if (root) root.LyricsLang = api;
})(typeof self !== 'undefined' ? self : (typeof window !== 'undefined' ? window : null), function () {
    'use strict';

    var FUNCTION_WORDS = {
        en: "the and you to of my me is in i i'm your it it's that be with for on all we are not this so what don't can just like when now never know was were have will but no do up down yeah got gonna wanna",
        de: 'und die der das ich du nicht ist ein eine einen mich dich mir dir mein meine dein deine wir ihr sie es zu mit auf für auch noch nur wenn aber doch schon immer nie hab habe bin bist sind kann will kein keine was wie wo den dem des im am vom zum',
        es: 'el la los las que y en un una no me te mi mis tu tus se lo por para con es yo si más mas como pero todo cuando qué estoy eres soy hay muy sin del al nos ya este esta quiero puedo porque',
        pt: 'o os as que e não eu você meu minha com um uma do da dos das em se é te no na pra para mais mas como tudo quando sou estou isso esse essa ele ela nós vai tem só já ao pelo pela',
        fr: "le la les de des du et je tu il elle un une que qui ne pas dans en pour sur avec mon ma mes ton ta tes est c'est j'ai suis au on nous vous plus tout comme mais moi toi ce cette sans",
        it: 'il lo gli che e un una non mi ti si per con sono sei è ma come più tutto quando io lui lei noi voi del della nel nella questo questa ho hai anche',
        id: 'yang dan aku kau kamu di ke dari ini itu tak tidak akan dengan untuk ada dalam saya kita kami engkau bisa sudah juga tapi jika karena sama lagi pada mau apa selalu',
        nl: 'de het een en van ik je jij niet dat die op te met zijn voor maar mijn wat ook nog als er naar bij om kan wil weet nu',
        pl: 'i w nie się na to że z do jest jak mnie ci ja ty co tak ale po już tylko mój moja jestem',
        tr: 've bir bu ben sen ne mi ki için ile çok ama gibi var yok beni seni benim senin her daha hiç',
    };
    var SET = {}, SHARE = {};
    Object.keys(FUNCTION_WORDS).forEach(function (l) {
        SET[l] = {};
        FUNCTION_WORDS[l].split(' ').forEach(function (w) { if (w) { SET[l][w] = 1; SHARE[w] = (SHARE[w] || 0) + 1; } });
    });

    function words(line) {
        return String(line == null ? '' : line).toLowerCase().replace(/[’`´]/g, "'")
            .split(/[\s.,!?;:"()«»¡¿…—–\-\[\]]+/).filter(Boolean);
    }

    function scoreWords(ws) {
        var sc = {}, l, i;
        for (l in SET) sc[l] = 0;
        for (i = 0; i < ws.length; i++) {
            var w = ws[i], share = SHARE[w];
            if (!share) continue;
            for (l in SET) if (SET[l][w]) sc[l] += 1 / share;
        }
        return sc;
    }

    function best(sc) {
        var b = null, second = 0, l;
        for (l in sc) {
            if (b === null || sc[l] > sc[b]) { if (b !== null) second = Math.max(second, sc[b]); b = l; }
            else second = Math.max(second, sc[l]);
        }
        return { lang: b, score: b ? sc[b] : 0, second: second };
    }

    function scriptOf(text) {
        var s = String(text || ''), n = { lat: 0, cyr: 0, hang: 0, arab: 0, other: 0 };
        for (var i = 0; i < s.length; i++) {
            var c = s.charCodeAt(i);
            if (c >= 0x0400 && c <= 0x04FF) n.cyr++;
            else if ((c >= 0x41 && c <= 0x5A) || (c >= 0x61 && c <= 0x7A) || (c >= 0xC0 && c <= 0x24F)) n.lat++;
            else if ((c >= 0xAC00 && c <= 0xD7A3) || (c >= 0x1100 && c <= 0x11FF) || (c >= 0x3130 && c <= 0x318F)) n.hang++;
            else if ((c >= 0x0600 && c <= 0x06FF) || (c >= 0x0750 && c <= 0x077F)) n.arab++;
            else if (c > 0x24F && /\p{L}/u.test(s[i])) n.other++;
        }
        var total = n.lat + n.cyr + n.hang + n.arab + n.other;
        if (!total) return { script: 'none', n: n };
        var top = 'latin', v = n.lat;
        if (n.cyr > v) { top = 'cyrillic'; v = n.cyr; }
        if (n.hang > v) { top = 'hangul'; v = n.hang; }
        if (n.arab > v) { top = 'arabic'; v = n.arab; }
        if (n.other > v) { top = 'other'; v = n.other; }
        return { script: top, n: n };
    }

    /* Ukrainian or Russian: the site's one detector (timbrica-core,
       window.__cyrillicLang), not «is there an і» — a Russian song naming
       «Київ» went to the Ukrainian voice. Cyrillic of another language stays
       on the Russian lane (GigaAM), as Tatar and Bashkir always did. */
    function cyrillicLang(text) {
        var g = typeof self !== 'undefined' ? self : (typeof window !== 'undefined' ? window : null);
        var f = g && g.__cyrillicLang;
        return typeof f === 'function' && f(text) === 'uk' ? 'uk' : 'ru';
    }

    function detect(lines, opts) {
        opts = opts || {};
        var arr = (lines || []).map(function (l) { return String(l == null ? '' : l); });
        var sc = scriptOf(arr.join('\n'));
        var hint = String(opts.hint || '').slice(0, 2).toLowerCase();
        var out = { lang: null, script: sc.script, confident: false, perLine: [], scores: {} };
        if (sc.script === 'none' || sc.script === 'other') { out.perLine = arr.map(function () { return null; }); return out; }
        if (sc.script !== 'latin') {
            out.lang = sc.script === 'cyrillic' ? cyrillicLang(arr.join('\n')) : (sc.script === 'hangul' ? 'ko' : 'ar');
            out.confident = true;
            out.perLine = arr.map(function () { return out.lang; });
            return out;
        }
        var all = [];
        arr.forEach(function (l) { all = all.concat(words(l)); });
        var s = scoreWords(all), b = best(s);
        out.scores = s;
        if (b.lang && b.score >= 3 && b.score >= 1.25 * b.second) { out.lang = b.lang; out.confident = true; }
        // weak evidence still beats a guess from the page locale: two English
        // lines pasted on /de are English
        else if (b.lang && b.score > 0 && !(SET[hint] && s[hint] >= b.score)) out.lang = b.lang;
        else out.lang = SET[hint] ? hint : 'en';
        /* A line leaves the song's language only on evidence: two DIFFERENT
           function words of the other language and none of the song's. Filler
           syllables ("la di da di", "lalala") repeat one word and stay put. */
        out.perLine = arr.map(function (l) {
            var ws = words(l), ls = scoreWords(ws), lb = best(ls);
            if (!lb.lang || lb.lang === out.lang || ls[out.lang] > 0) return out.lang;
            var distinct = {}, k;
            for (k = 0; k < ws.length; k++) if (SET[lb.lang][ws[k]]) distinct[ws[k]] = 1;
            return Object.keys(distinct).length >= 2 ? lb.lang : out.lang;
        });
        return out;
    }

    return { detect: detect, scriptOf: scriptOf, FUNCTION_WORDS: FUNCTION_WORDS };
});
